import Alpine from 'alpinejs';
import { NotificationInstance, CreateNotificationInstanceArgs } from './types';

export class NotificationStore {
    /**
     * Holds the instances of the notification component.
     */
    private instances: Record<string, NotificationInstance> = {};

    // TODO(jozsef.kiraly): Change this ID to `notifications` later when other notification solutions
    // have been removed from the codebase
    private containerId = 'alpine-notifications';

    private animationDelay = 300;

    private defaultDuration = 5000;

    constructor() {
        this.instances = Alpine.reactive({});
        this.init();
    }

    init() {
        if (!this._containerExists()) {
            console.error(`Notification container not found with ID: ${this.containerId}`);
        }
    }

    create({
        type = 'success',
        message,
        duration = this.defaultDuration,
        contentPosition = 'center',
    }: CreateNotificationInstanceArgs) {
        const id = Math.random().toString(36);

        this.instances[id] = {
            id,
            type,
            message,
            duration,
            visible: false,
            contentPosition,
        };

        this._withAnimationDelay(() => {
            this.instances[id].visible = true;
            setTimeout(() => this.remove(id), duration);
        });

        return id;
    }

    remove(id: string) {
        this.instances[id].visible = false;

        this._withAnimationDelay(() => {
            delete this.instances[id];
        });
    }

    getAnimationDelay() {
        return this.animationDelay;
    }

    getInstances() {
        return this.instances;
    }

    _withAnimationDelay(callback: () => void) {
        setTimeout(callback, this.animationDelay);
    }

    _containerExists() {
        return !!document.getElementById(this.containerId);
    }
}
